var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-template","size":"xl","title":"Pilih Pemeriksaan","hide-footer":""}},[_c('Table',{attrs:{"purpose":"modal-template"},on:{"chooseTemplate":_vm.chooseTemplate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }